import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import i18n from './lang/i18n';
import './assets/scss/common.scss';
import Validate from './plugins/validate';
import Scroller from './lib/scroller';
import Helper from './lib/helper';
import Card from './components/ui/Card';
import CardForm from './components/ui/CardForm';
import {format, parse} from "date-fns";
import numeral from 'numeral';
import numFormat from 'vue-filter-number-format';
import Value from './lib/value';
import socket from "./lib/socket";
import CSwitch from "./components/ui/CSwitch";
import BtnsWrap from "./components/ui/BtnsWrap";
import CBtn from "./components/ui/CBtn";

Vue.config.productionTip = false;

Vue.use(Validate, {
    i18n,
    events: 'change'
});

Vue.use(Scroller);
Vue.use(Helper);
Vue.use(Value);
Vue.use(socket);

Vue.component('card', Card);
Vue.component('card-form', CardForm);
Vue.component('c-switch', CSwitch);
Vue.component('btns-wrap', BtnsWrap);
Vue.component('c-btn', CBtn);

Vue.filter('numFormat', numFormat(numeral));
Vue.filter('dateTime', value => {
    if (value === undefined || value === null) return null;
    return format(new Date(value), 'yyyy-MM-dd HH:mm:ss')
});
Vue.filter('dateMin', value => {
    if (value === undefined || value === null) return null;
    return format(new Date(value), 'HH:mm')
});
Vue.filter('date', (value) => format(new Date(value), 'yyyy-MM-dd'));

new Vue({
    router,
    store,
    vuetify,
    i18n,
    render: h => h(App)
}).$mount('#app');
